export enum RevenueReportFilterType {
  PRODUCT = "PRODUCT",
  PLAN = "PLAN",
  SUBSCRIPTION = "SUBSCRIPTION",
  INVOICE = "INVOICE"
}